import {Component, Input, OnInit} from '@angular/core';
import { OptionService } from "../option/option.service";
import {Donation} from "../donation/donation";

@Component({
    selector: 'payment-iframe',
    templateUrl: './payment.iframe.component.html',
    host: {
        '(window:message)': 'gotMessage($event)',
    },
})
export class PaymentIframeComponent implements OnInit {
    /**
     * the current donation
     */
    @Input() donation: Donation;

    /**
     * List of placehodlers for the submit button
     */
    @Input() buttonPlaceholders: any;

    /**
     * Type of the project
     */
    @Input() projectType: string = null;

    /**
     * Id of the iframe
     * @type {string}
     */
    twingleID: string = "twingle-payment-iframe";

    /**
     * holds the current height of the iframe
     * @type {number}
     */
    height: number = 0;

    /**
     * Textkey for the last submit Button
     */
    paymentSubmitTextkey: string = 'payment.submit.now';

    /**
     * The constructor
     * @param optionService
     */
    constructor(private optionService: OptionService) { }

    /**
     * Initialize the component
     */
    public ngOnInit(): any {
        if(this.projectType === 'membership') {
            this.paymentSubmitTextkey = 'payment.submit.now.membership';
        }
    }

    /**
     * Messagehandler for the iframe to resize it
     * @param message
     */
    gotMessage(message: any) {
        if(message && message.data && message.data.indexOf("height:") === 0) {
            let height = message.data.split(":");
            if(height && height.length > 0 && (height[1] * 1) != this.height) {
                document.getElementById("twingle-payment-iframe").style.height = height[1] + "px";
                this.height = height[1] * 1;
            }
        }

    }

    /**
     * Returns a textkey for the headline, depending on the payment method
     * @returns {string}
     */
    paymentHeadline(): string {
        return "payment.headline.iframe." + this.donation.paymentMethod;
    }

    /**
     * Submit the iframe
     */
    submitIframe(): void {
        switch(this.donation.paymentMethod) {
            case "betterpayment_creditcard":
                console.log("Submitting form");
                (<HTMLIFrameElement>document.getElementById(this.twingleID)).contentWindow.postMessage("submit", "*");
                break;
            default:
                console.error("Don't know how to submit");
        }
    }
}
